// extracted by mini-css-extract-plugin
export default {"heading":"ready_heading__JdK2K","element":"ready_element__j0nRQ","imageWrap":"ready_imageWrap__IB67I","image":"ready_image__HRAxi"};